export default __webpack_public_path__ + "static/media/new-year.7f8c6a51.mp3";